import { render, staticRenderFns } from "./PetOwnerRegisterOTP.vue?vue&type=template&id=28a4bcea&scoped=true&"
import script from "./PetOwnerRegisterOTP.vue?vue&type=script&lang=js&"
export * from "./PetOwnerRegisterOTP.vue?vue&type=script&lang=js&"
import style0 from "./PetOwnerRegisterOTP.vue?vue&type=style&index=0&id=28a4bcea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a4bcea",
  null
  
)

export default component.exports